import React from 'react';
import PropTypes from 'prop-types';
import { Route, Switch, Redirect } from 'react-router';

import withAutorization from 'HELPERS/withAuthorization/withAuthorization';
import { MainLayout } from 'COMPONENTS/Layout';
import { DateReminder, ControlPageSidebar } from './index';
import { ScheduleDate, ResendNewsletter, GenerateCampaign } from './Screens';

const ControlPage = props => (
  <MainLayout sidebar={<ControlPageSidebar />} renderBefore={() => <DateReminder />}>
    <Route exact path={props.match.url} render={() => <h2>Control Dashboard</h2>} />
    <div className="control-page-content">
      <Switch>
        <Route path={`${props.match.url}/schedule-date`} component={ScheduleDate} />
        <Route path={`${props.match.url}/generate-preview`} component={GenerateCampaign} />
        <Route path={`${props.match.url}/resend-newsletter`} component={ResendNewsletter} />
        <Redirect from="*" to="/control/generate-preview" />
      </Switch>
    </div>
  </MainLayout>
);

ControlPage.propTypes = {
  match: PropTypes.object.isRequired,
};

export { ControlPage as PureControlPage };
export default withAutorization(ControlPage);



// WEBPACK FOOTER //
// ./src/pages/Control/ControlPage.js